/* AeroSims — Sprachvorschlag.
   Zeigt Besuchern, deren Browsersprache wir führen, einen Hinweis auf ihre Sprachfassung.
   BEWUSST KEINE automatische Weiterleitung: Googlebot crawlt mit englischem Header aus den USA;
   ein harter Redirect würde die 19 übersetzten Fassungen aus dem Index nehmen und den
   hreflang-Tags widersprechen. Ein Vorschlag ist auch Googles ausdrückliche Empfehlung.
   Läuft rein clientseitig, ändert nichts am ausgelieferten Inhalt. */
(function () {
  'use strict';
  try {
    if (!window.navigator || !document.body) return;

    /* Sprachkürzel → URL-Präfix, exakt wie in den Markt-Einstellungen hinterlegt */
    var URLS = {
      en: '/', ar: '/ar/', de: '/de/', es: '/es/', fr: '/fr/', he: '/he/', hi: '/hi/',
      id: '/id/', it: '/it/', ja: '/ja/', ko: '/ko/', nl: '/nl/', pl: '/pl/', pt: '/pt/',
      ru: '/ru/', sq: '/sq/', sr: '/sr/', tr: '/tr/', zh: '/zh-hans/', zhTW: '/zh-hant/'
    };

    /* Banner-Texte jeweils IN der Zielsprache — sonst versteht sie der Adressat nicht */
    var T = {
      de: ['Diese Seite auf Deutsch ansehen?', 'Zu Deutsch wechseln', 'Nein, danke'],
      fr: ['Voir cette page en français ?', 'Passer au français', 'Non merci'],
      it: ['Vuoi vedere questa pagina in italiano?', 'Passa all’italiano', 'No, grazie'],
      es: ['¿Ver esta página en español?', 'Cambiar a español', 'No, gracias'],
      pt: ['Ver esta página em português?', 'Mudar para português', 'Não, obrigado'],
      nl: ['Deze pagina in het Nederlands bekijken?', 'Naar Nederlands', 'Nee, bedankt'],
      pl: ['Zobaczyć tę stronę po polsku?', 'Przełącz na polski', 'Nie, dziękuję'],
      ru: ['Открыть эту страницу на русском?', 'Перейти на русский', 'Нет, спасибо'],
      tr: ['Bu sayfayı Türkçe görmek ister misin?', 'Türkçeye geç', 'Hayır, teşekkürler'],
      id: ['Lihat halaman ini dalam bahasa Indonesia?', 'Ganti ke bahasa Indonesia', 'Tidak, terima kasih'],
      ja: ['このページを日本語で表示しますか？', '日本語に切り替える', '表示しない'],
      ko: ['이 페이지를 한국어로 보시겠어요?', '한국어로 보기', '괜찮습니다'],
      zh: ['用简体中文查看此页面？', '切换到简体中文', '不用了'],
      zhTW: ['以繁體中文檢視此頁面？', '切換至繁體中文', '不用了'],
      ar: ['هل تريد عرض هذه الصفحة بالعربية؟', 'التبديل إلى العربية', 'لا، شكرًا'],
      he: ['להציג את הדף הזה בעברית?', 'מעבר לעברית', 'לא, תודה'],
      hi: ['इस पेज को हिन्दी में देखें?', 'हिन्दी में देखें', 'नहीं, धन्यवाद'],
      sr: ['Želiš da vidiš ovu stranicu na srpskom?', 'Pređi na srpski', 'Ne, hvala'],
      sq: ['Dëshiron ta shohësh këtë faqe në shqip?', 'Kalo në shqip', 'Jo, faleminderit']
    };
    var RTL = { ar: 1, he: 1 };

    /* 0) NICHT auf der My-eSIM-Seite: deren Sprache kommt aus dem Link der
       Zustellmail und ist damit bereits die richtige. */
    if (/\/pages\/my-esim\/?$/.test(location.pathname)) return;
    /* 2.9.2026: nie im Warenkorb (Kaufmoment), nur einmal je Sitzung */
    if (/^(?:\/[a-z]{2}(?:-[a-zA-Z]+)?)?\/cart\/?$/.test(location.pathname)) return;
    try { if (sessionStorage.getItem('as_ls_seen')) return; } catch (e) {}

    /* 1) Welche Sprache zeigt die Seite gerade? Der URL-Präfix ist das eindeutigste Signal. */
    var path = location.pathname;
    var cur = 'en';
    for (var k in URLS) {
      if (URLS[k] === '/') continue;
      /* 2.9.2026: Shopify liefert die Sprachwurzel OHNE Schraegstrich am Ende ("/de").
         Ohne diesen Vergleich hielt das Skript die deutsche Startseite fuer die englische
         und schlug dort Deutsch vor — auf genau der Seite, die schon deutsch war. */
      if (path === URLS[k].slice(0, -1) || path.indexOf(URLS[k]) === 0) { cur = k; break; }
    }

    /* 2) Was spricht der Browser? Erste Übereinstimmung gewinnt. */
    var prefs = navigator.languages && navigator.languages.length
      ? navigator.languages : [navigator.language || ''];
    var want = null;
    for (var i = 0; i < prefs.length && !want; i++) {
      var p = String(prefs[i] || '').toLowerCase();
      if (!p) continue;
      if (p.indexOf('zh') === 0) {
        want = (p.indexOf('tw') > -1 || p.indexOf('hant') > -1 || p.indexOf('hk') > -1 || p.indexOf('mo') > -1) ? 'zhTW' : 'zh';
      } else {
        var base = p.split('-')[0];
        if (base === 'pt') want = 'pt';
        else if (URLS[base]) want = base;
      }
    }
    if (!want || want === cur) return;          // schon richtig, oder Sprache führen wir nicht
    if (want === 'en' && cur === 'en') return;
    if (!T[want]) return;                        // Englisch braucht keinen Vorschlag

    /* 3) Einmal weggeklickt = dauerhaft Ruhe (pro Zielsprache) */
    var KEY = 'as_langsuggest_' + want;
    try { if (localStorage.getItem(KEY)) return; } catch (e) { /* privater Modus */ }

    /* 4) Ziel-URL: Präfix + aktueller Pfad. Shopify leitet auf übersetzte Handles weiter. */
    var rest = path;
    if (cur !== 'en') rest = path.slice(URLS[cur].length - 1);   // altes Präfix abschneiden
    var target = (URLS[want] + rest.replace(/^\/+/, '')).replace(/\/{2,}/g, '/') + location.search;

    var txt = T[want], rtl = !!RTL[want];

    /* 5) Banner bauen — 2.9.2026: erst NACH dem Cookie-Banner (beide lagen uebereinander), 44-px-Knoepfe,
       Reihenfolge Frage -> Nein -> Ja, Hoehe als CSS-Variable (Chat-Blase rueckt exakt darueber), einmal je Sitzung. */
    function build() {
      try { if (sessionStorage.getItem('as_ls_seen')) return; sessionStorage.setItem('as_ls_seen', '1'); } catch (e) {}
      var bar = document.createElement('div');
      bar.id = 'as-langsuggest';
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', txt[0]);
      bar.setAttribute('aria-live', 'polite');
      bar.dir = rtl ? 'rtl' : 'ltr';
      bar.style.cssText = [
        'position:fixed', 'left:0', 'right:0', 'bottom:0', 'z-index:2147483000',
        'background:#0c1535', 'color:#fff', 'padding:10px 16px calc(10px + env(safe-area-inset-bottom, 0px))',
        'font:500 14px/1.4 -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif',
        'display:flex', 'align-items:center', 'justify-content:center', 'gap:4px 12px',
        'flex-wrap:wrap', 'box-shadow:0 -6px 24px rgba(0,0,0,.18)',
        'transform:translateY(100%)', 'transition:transform .28s ease'
      ].join(';');

      var label = document.createElement('span');
      label.textContent = txt[0];
      label.style.cssText = 'flex:1 1 100%;text-align:center;font-size:13px';

      var go = document.createElement('a');
      go.href = target;
      go.textContent = txt[1];
      go.style.cssText = 'background:#00c8e0;color:#0c1535;text-decoration:none;font-weight:800;' +
        'min-height:44px;display:inline-flex;align-items:center;padding:0 18px;border-radius:10px;white-space:nowrap';

      var no = document.createElement('button');
      no.type = 'button';
      no.textContent = txt[2];
      no.style.cssText = 'background:none;border:0;color:#c9d4ea;font:inherit;cursor:pointer;' +
        'min-height:44px;display:inline-flex;align-items:center;padding:0 12px;text-decoration:underline;white-space:nowrap';

      function close() {
        try { localStorage.setItem(KEY, '1'); } catch (e) { /* egal */ }
        bar.style.transform = 'translateY(100%)';
        document.body.classList.remove('as-ls-open');
        setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 300);
      }
      no.addEventListener('click', close);
      go.addEventListener('click', function () { try { localStorage.setItem(KEY, '1'); } catch (e) {} });

      bar.appendChild(label); bar.appendChild(no); bar.appendChild(go);
      document.body.appendChild(bar);
      document.body.classList.add('as-ls-open');
      requestAnimationFrame(function () {
        bar.style.transform = 'translateY(0)';
        try { document.documentElement.style.setProperty('--as-ls-h', bar.offsetHeight + 'px'); } catch (e) {}
      });
    }
    /* Cookie-Gate: solange #ccb sichtbar ist, warten; nach der Entscheidung (Klasse weg) bauen. Ohne Banner sofort. */
    var ccb = document.getElementById('ccb');
    function ccbOpen() { return !!(ccb && ccb.classList.contains('ccb--visible')); }
    if (!ccb) { build(); }
    else {
      var seen = ccbOpen(), done = false;
      function maybe() { if (done) return; if (ccbOpen()) { seen = true; return; } if (seen) { done = true; build(); } }
      try { new MutationObserver(maybe).observe(ccb, { attributes: true, attributeFilter: ['class'] }); } catch (e) { done = true; build(); }
      setTimeout(function () { if (!done && !ccbOpen()) { done = true; build(); } }, 3000);
    }
  } catch (e) { /* ein Sprachhinweis darf niemals eine Seite kaputt machen */ }
})();
